import { FETCH_TICKETS_SUCCESS, FETCH_TICKETS_FAIL } from './actionTypes';

const initialState = {
  tickets: [],
  error: null,
  hasUnreadMessages: false,
  total_items_count: 0,
  total_pages_count: 0
};

const Tickets = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TICKETS_SUCCESS:
      return {
        ...state,
        tickets: action.payload.items,
        total_items_count: action.payload.total_items_count,
        total_pages_count: action.payload.total_pages_count,
        hasUnreadMessages: action.payload.items.some(ticket => ticket.unread_messages),
        error: null,
      };

    case FETCH_TICKETS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Tickets;
